import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';

export const DeleteSpaceMemberValidationSchema = z.object({
  userId: z.string({ message: 'User ID is required' }).min(1),
  spaceId: z.string({ message: 'Space ID is required' }).min(1),
  organizationId: z.string({ message: 'Organization ID is required' }).min(1),
});
export type TDeleteSpaceMemberValidation = z.infer<typeof DeleteSpaceMemberValidationSchema>;
export type TDeleteSpaceMemberPayload = TDeleteSpaceMemberValidation;
export type TDeleteSpaceMemberResponse = ApiResponse<{
  message: string;
}>;

export const deleteSpaceMember = (payload: TDeleteSpaceMemberPayload): Promise<TDeleteSpaceMemberResponse> => {
  const url = `/space-member?userId=${payload.userId}&spaceId=${payload.spaceId}&organizationId=${payload.organizationId}`;

  return axiosInstance.delete(url);
};

/**
 * Use Delete Space Member React-Query Hook
 */
type UseDeleteSpaceMemberMutationOptions = {
  mutationConfig?: TypedMutationConfig<typeof deleteSpaceMember, AxiosErrorCustom>;
};

export const useDeleteSpaceMemberMutation = ({ mutationConfig }: UseDeleteSpaceMemberMutationOptions) => {
  const { ...restConfig } = mutationConfig ?? {};

  return useMutation({
    mutationFn: deleteSpaceMember,
    ...restConfig,
  });
};
